export enum XIDItemType {
	XC = 'xc',
	UID = 'uid',
}

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export enum XIDState {
	NEW = 'NEW',
	CHANGED = 'CHANGED',
	EXISTING = 'EXISTING',
	TIMEOUT = 'TIMEOUT',
	ERROR = 'ERROR',
	UNAVAILABLE = 'UNAVAILABLE',
	MALFORMED = 'MALFORMED',
	UNKNOWN = 'UNKNOWN',
}
